<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col>
                    <BookingNav></BookingNav>
                </b-col>
            </b-row>
        </div>
        <div>
            <div class="booking-body">
                <div class="booking-content customers-wrapper">
                    <b-row>
                        <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                            <div class="filter-wrapper">
                                <b-form-select v-model="selectedClass"
                                               :options="classOptions"/>
                            </div>
                        </b-col>
                        <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                            <div class="filter-wrapper">
                                <b-input-group prepend=" ">
                                    <b-form-input placeholder="Search"
                                                    @keydown.enter.native="search()"
                                                    v-model="searchString">
                                    </b-form-input>
                                    <b-dropdown text="Advanced" variant="primary" slot="append">
                                        <b-dropdown-item v-for="searchField in searchableFields"
                                                            :key="searchField.value"
                                                            @click="searchOption(searchField.value)">
                                            {{ searchField.text }}
                                            <i v-if="selectedSearchOption.indexOf(searchField.value) !== -1" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1" style="margin-top: -2px; margin-right: 0px;">
                                            </i>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group>
                            </div>
                        </b-col>
                        <b-col sm="3" md="3">
                            <b-button variant="primary" class="d-inline-block new-button align-top" @click="showModal('new-package')">
                                + Package
                            </b-button>
                            <AddPackage :image="form.image" :logoStamp="form.logoStamp" @clearImage="clearPackageImg" @clearImageLogoStamp="clearPackageImgLogoStamp"></AddPackage>
                        </b-col>
                    </b-row>
                    <template v-if="packages.length > 0">
                        <b-row class="mt-3" no-gutters>
                            <b-col>
                                <div>
                                    <b-card-group deck>
                                        <b-card class="class-container" v-for="(item) in packages" :key="item.uuid">
                                            <b-row no-gutters>
                                                <b-col>
                                                    <template v-if="item.visibility">
                                                        <div class="visible-on" style="height: 27px; padding: 0px;">
                                                            ON
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="visible-off" style="height: 27px; padding: 0px;">
                                                            OFF
                                                        </div>
                                                    </template>
                                                </b-col>
                                                <b-col class="text-right align-middle">
                                                    <img src="../../assets/images/actions/edit.svg" alt="Edit Button" class="action-button ml-1" @click="confirmEdit(item.uuid)">
                                                    <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="action-button ml-1" @click="callDelete(item.uuid, item.name)">
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <div class="banner mt-2">
                                                        <img :src="item.image" alt="Banner Image">
                                                    </div>
                                                    <h6 class="class-title mt-3 mb-2">{{ item.name }}</h6>
                                                    <p class="class-details mb-4">{{ item.description }}</p>
                                                </b-col>
                                            </b-row>
                                            <div slot="footer">
                                                <b-row no-gutters>
                                                    <b-col>
                                                        <div id="package-badge" class="border rounded-circle mx-auto">
                                                            <img :src="item.logo_stamp" alt="Logo Stamp">
                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="package-details-wrapper">
                                                            <p class="mb-2">Visits: <span class="detail">{{ item.no_of_visits }}</span></p>
                                                            <p class="mb-2">Validity: <span class="detail">{{ item.duration }} {{ item.duration_type }}(s)</span></p>
                                                            <p class="mb-2">Price: <span class="detail">Php {{ item.price }}</span></p>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-card>
                                        <template v-if="packages.length < 4">
                                            <b-card class="blank-package" v-for="index in (4 - packages.length)" :key="index">
                                            </b-card>
                                        </template>
                                    </b-card-group>
                                </div>
                            </b-col>
                            <b-col cols="1">
                                <img class="news-add-button d-block mx-auto" src="../../assets/images/icons/add.svg" alt="Add Icon" @click="showModal('new-package')">
                            </b-col>
                        </b-row>
                    </template>
                    <template v-else>
                        <b-row>
                            <b-col>
                                <div class="empty-add-news text-center mt-3">
                                    <h2>Create Package</h2>
                                    <img class="add-button d-block mx-auto mt-2" src="../../assets/images/icons/add.svg" alt="Add Icon" @click="showModal('new-package')">
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                    <div class="mt-3">
                        <b-row no-gutters>
                            <b-col>
                                <div class="mt-1">
                                    <span class="pagination-indicator">Showing {{ currentFirstItem }} to {{ currentLastItem }} of {{ maxPage}} pages</span>
                                </div>
                            </b-col>
                            <b-col>
                                <b-pagination
                                    hide-goto-end-buttons
                                    align="right" 
                                    size="md"
                                    :total-rows="(totalPerPage > 0 ) ? maxPage * totalPerPage : 1"
                                    :limit="(totalPerPage > 0 ) ? 5 : 1"
                                    :per-page="totalPerPage"
                                    @change="paginate"
                                    class="custom-pagination">
                                </b-pagination>
                            </b-col>
                            <b-col cols="1"></b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="packageUploadImage"
            title="Upload Image"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
        >
            <div id="package-image-upload-container" class="border mx-auto">
                <croppa 
                    v-model="croppa"
                    @new-image-drawn="onNewImage"
                    @zoom="onZoom"
                    :width="340"
                    :height="190"
                    placeholder="Choose an Image"
                    :show-remove-button="true"
                    :placeholder-font-size="14"
                    remove-button-color="#ff8828">
                </croppa>
            </div>
            <div id="package-image-range-container" class="mx-auto mt-2">
                <input type="range" class="custom-range" id="customRange1" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal">
            </div>
            <div slot="modal-footer">
                <b-button variant="ghost" class="btn-cancel" @click="cancelUploadImageModal(true)" style="margin-right: .25rem;">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="hideUploadImageModal(true)" style="margin-left: .25rem;">
                    Save
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="packageUploadLogoStamp"
            title="Upload Image"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
        >
            <div id="logo-stamp-upload-container" class="border mx-auto rounded-circle">
                <croppa 
                    v-model="croppaLogoStamp"
                    @new-image-drawn="onNewImageLogoStamp"
                    @zoom="onZoomLogoStamp"
                    :width="200"
                    :height="200"
                    placeholder="Choose an Image"
                    :show-remove-button="true"
                    :placeholder-font-size="14"
                    remove-button-color="#ff8828">
                </croppa>
            </div>
            <div id="logo-stamp-range-container" class="mx-auto mt-2">
                <input type="range" class="custom-range" id="customRange2" @input="onSliderChangeLogoStamp" :min="sliderMinLogoStamp" :max="sliderMaxLogoStamp" step=".001" v-model="sliderValLogoStamp">
            </div>
            <div slot="modal-footer">
                <b-button variant="ghost" class="btn-cancel" @click="cancelUploadLogoStampModal(true)" style="margin-right: .25rem;">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="hideUploadLogoStampModal(true)" style="margin-left: .25rem;">
                    Save
                </b-button>
            </div>
        </b-modal>
        <EditPackage :form="packageDetails" :image="form.image" :logoStamp="form.logoStamp" @clearImage="clearPackageImg" @clearImageLogoStamp="clearPackageImgLogoStamp"></EditPackage>
        <b-modal id="delete-modal" title="Confirm Delete">
            <p class="modal-main-message">Are you sure you want to delete <strong>{{ deletePackageName }}</strong>?</p>
            <div slot="modal-footer">
                <b-button variant="ghost" v-bind:disabled="loading" class="btn-cancel" style="margin-right: .25rem;" @click="hideModal('delete-modal')">
                    Cancel
                </b-button>
                <b-button variant="primary" v-bind:disabled="loading" style="margin-left: .25rem;" @click="deletePackage">
                    <template v-if="loading">
                        Deleting...
                    </template>
                    <template v-else>
                        Yes, Delete
                    </template>
                </b-button>
                <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
            </div>
        </b-modal>
        <b-modal id="edit-confirmation-modal" title="Confirm Edit">
            <p class="modal-main-message">Updating this package may affect those that were already purchased. Are you sure you want to continue?</p>
            <div slot="modal-footer">
                <b-button variant="ghost" class="btn-cancel" style="margin-right: .25rem;" @click="hideModal('edit-confirmation-modal')">
                    Cancel
                </b-button>
                <b-button variant="primary" style="margin-left: .25rem;" @click="callDisplay(editUuid)">
                    Yes
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import BookingNav from "./BookingNav.vue";
import Datepicker from "vue-bulma-datepicker";
import Switches from "vue-switches";
import { mapState } from "vuex";
import AddPackage from "./package/AddPackage";
import EditPackage from "./package/EditPackage";

export default {
    name: "package",
    data() {
        return {
            selectedClass: "all",
            classOptions: [{ value: "all", text: "All Packages" }],
            daterangeConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                static: true,
                mode: "range",
                defaultDate: ["today", "today"]
            },
            form: {
                name: "",
                description: "",
                image: "",
                noOfVisits: "",
                duration: "",
                durationType: "days",
                price: "",
                visibility: false,
                logoStamp: ""
            },
            croppa: {},
            croppaLogoStamp: {},
            sliderVal: 0,
            sliderMin: 0,
            sliderMax: 0,
            sliderValLogoStamp: 0,
            sliderMinLogoStamp: 0,
            sliderMaxLogoStamp: 0,
            deleteUuid: "",
            deletePackageName: "",
            searchString: "",
            selectedSearchOption: [],
            searchPayload: null,
            editUuid: ""
        };
    },
    components: {
        BookingNav,
        Datepicker,
        Switches,
        AddPackage,
        EditPackage
    },
    computed: {
        ...mapState("packages", [
            "loading",
            "packages",
            "packageDetails",
            "maxPage",
            "nextPage",
            "prevPage",
            "currentPage",
            "totalPerPage",
            "searching",
            "currentFirstItem",
            "currentLastItem",
            "initialPageCount",
            "searching",
            "errors",
            "editing",
            "searchableFields"
        ])
    },
    created() {
        this.getPackages(1);
    },
    methods: {
        async getPackages(page) {
            let param = {
                page: page,
                payload: this.searchPayload
            };
            await this.$store.dispatch("packages/getPackages", param);
        },
        async callDisplay(uuid) {
            let _this = this;

            this.$store.dispatch("packages/editing");

            await this.$store
                .dispatch("packages/viewPackage", uuid)
                .then(function() {
                    _this.showModal("edit-modal");
                });
        },
        async confirmEdit(uuid) {
            this.editUuid = uuid;
            let _this = this;
            _this.showModal("edit-confirmation-modal");
        },
        async showModal(modal) {
            (await (modal == "edit-modal"))
                ? this.$store.dispatch("packages/editing")
                : this.$store.dispatch("packages/resetEditing");

            this.$store.dispatch("packages/resetErrors");

            this.$root.$emit("bv::show::modal", modal);
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        onNewImage() {
            this.sliderVal = this.croppa.scaleRatio;
            this.sliderMin = this.croppa.scaleRatio / 2;
            this.sliderMax = this.croppa.scaleRatio * 2;
        },
        onSliderChange(evt) {
            var increment = evt.target.value;
            this.croppa.scaleRatio = +increment;
        },
        onZoom() {
            this.sliderVal = this.croppa.scaleRatio;
        },
        onNewImageLogoStamp() {
            // Logo Stamp
            this.sliderValLogoStamp = this.croppaLogoStamp.scaleRatio;
            this.sliderMinLogoStamp = this.croppaLogoStamp.scaleRatio / 2;
            this.sliderMaxLogoStamp = this.croppaLogoStamp.scaleRatio * 2;
        },
        onSliderChangeLogoStamp(evt) {
            var increment = evt.target.value;
            this.croppaLogoStamp.scaleRatio = +increment;
        },
        onZoomLogoStamp() {
            this.sliderValLogoStamp = this.croppaLogoStamp.scaleRatio;
        },
        cancelUploadImageModal(forceClose = false) {
            this.clearPackageImg();
            if (forceClose) {
                this.hideModal("packageUploadImage");
                this.editing
                    ? this.showModal("edit-modal")
                    : this.showModal("new-package");
            }
            return true;
        },
        hideUploadImageModal(forceClose = false) {
            if (this.croppa.generateDataUrl() === "") {
                return false;
            }

            this.form.image = this.croppa.generateDataUrl();

            if (forceClose) {
                this.hideModal("packageUploadImage");
                this.editing
                    ? this.showModal("edit-modal")
                    : this.showModal("new-package");
            }
            return true;
        },
        cancelUploadLogoStampModal(forceClose = false) {
            this.clearPackageImgLogoStamp();
            if (forceClose) {
                this.hideModal("packageUploadLogoStamp");
                // this.showModal("new-instructor");
                this.editing
                    ? this.showModal("edit-modal")
                    : this.showModal("new-package");
            }
            return true;
        },
        hideUploadLogoStampModal(forceClose = false) {
            if (this.croppaLogoStamp.generateDataUrl() === "") {
                return false;
            }

            this.form.logoStamp = this.croppaLogoStamp.generateDataUrl();

            if (forceClose) {
                this.hideModal("packageUploadLogoStamp");
                // this.showModal("new-instructor");
                this.editing
                    ? this.showModal("edit-modal")
                    : this.showModal("new-package");
            }
            return true;
        },
        clearPackageImg: function() {
            this.form.image = "";
            this.croppa.remove();
        },
        clearPackageImgLogoStamp: function() {
            this.form.logoStamp = "";
            this.croppaLogoStamp.remove();
        },
        deletePackage() {
            let _this = this;

            this.$store
                .dispatch("packages/deletePackage", this.deleteUuid)
                .then(function() {
                    _this.hideModal("delete-modal");
                    // if (_this.errors == null) _this.getPackages(_this.currentPage);
                    if (_this.errors == null) _this.getPackages(1);
                });
        },
        paginate(page) {
            // if (this.searching) {
            //     return this.search(false, page);
            // }
            return this.getPackages(page);
        },
        callDelete(uuid, packageName) {
            this.deleteUuid = uuid;
            this.deletePackageName = packageName;
            this.showModal("delete-modal");
        },
        clearSearch() {
            this.selectedSearchOption = [];
            this.search();
        },
        search() {
            let searchPayload = [];
            let _this = this;
            if (this.selectedSearchOption.length != 0 && this.searchString.trim() !== "") {
                _.forEach(_this.selectedSearchOption, function(field) {
                    searchPayload = {
                        keyword: _this.searchString.trim(),
                        filter: field
                    };
                });
            } else if (this.selectedSearchOption[0] === "enabled" || this.selectedSearchOption[0] === "disabled") {
                _.forEach(_this.selectedSearchOption, function(field) {
                    searchPayload = {
                        keyword: _this.searchString.trim(),
                        filter: field
                    };
                });
            }
            this.searchPayload = searchPayload;
            this.getPackages(1);
        },
        searchOption(value) {
            this.selectedSearchOption = [value];
            console.log(this.selectedSearchOption[0]);
            // if (this.searchString.trim() !== "") {
            //     this.search();
            // }
            this.search();
        },
    }
};
</script>
<style lang="scss">
</style>
